import {PositionInterface} from '../../../../interfaces';
import {PortalPermissionsEnum} from '../../../../enums';

export class PortalPermissionsPositionsEnumHelper {
    private constructor() {
    }

    static getPortalManagerialRightsPermissionPosition(permissionString: string): PositionInterface {
        switch (permissionString) {
            case PortalPermissionsEnum.CashAccountsCreateNew:
                return {col: 0, row: 0};
            case PortalPermissionsEnum.CashAccountsDelete:
                return {col: 0, row: 1};
            case PortalPermissionsEnum.AddBankAccount:
                return {col: 0, row: 2};
            case PortalPermissionsEnum.ViewBankAccount:
                return {col: 0, row: 3};
            case PortalPermissionsEnum.EditBankAccount:
                return {col: 0, row: 4};
            default:
                return {col: 0, row: 0};
        }
    }

    static getPortalCashOperationsPermissionPosition(permissionString: string): PositionInterface {
        switch (permissionString) {
            case PortalPermissionsEnum.CreateNewDeposits:
                return {col: 0, row: 0};
            case PortalPermissionsEnum.CreateNewWithdrawals:
                return {col: 0, row: 1};
            case PortalPermissionsEnum.NewInternalTransfer:
                return {col: 0, row: 2};
            case PortalPermissionsEnum.UpdatePaymentDetails:
                return {col: 0, row: 3};
            case PortalPermissionsEnum.CashOperationsViewTransactionHistoryAndPendingWithdrawals:
                return {col: 0, row: 4};
            default:
                return {col: 0, row: 0};
        }
    }

    static getPortalReportsPermissionPosition(permissionString: string): PositionInterface {
        switch (permissionString) {
            case PortalPermissionsEnum.ViewTradingAccountStatementsAndReports:
                return {col: 0, row: 0};
            case PortalPermissionsEnum.ViewGroupStatementsAndReports:
                return {col: 0, row: 1};
            default:
                return {col: 0, row: 0};
        }
    }

    static getPortalMdsPermissionPosition(permissionString: string): PositionInterface {
        switch (permissionString) {
            case PortalPermissionsEnum.SubscriptionManagementViewAssignedFeeds:
                return {col: 0, row: 0};
            case PortalPermissionsEnum.SubscriptionManagementEditAssignedFeeds:
                return {col: 0, row: 1};
            case PortalPermissionsEnum.SubscriptionManagementAssignFeedsToUsers:
                return {col: 0, row: 2};
            case PortalPermissionsEnum.SubscriptionManagementViewAvailableFeeds:
                return {col: 0, row: 3};
            case PortalPermissionsEnum.SubscriptionManagementViewFeedPrice:
                return {col: 0, row: 4};
            case PortalPermissionsEnum.SubscriptionManagementViewMarkups:
                return {col: 0, row: 5};
            case PortalPermissionsEnum.SubscriptionManagementSetMarkups:
                return {col: 0, row: 6};
            case PortalPermissionsEnum.SubscriptionManagementViewEventHistory:
                return {col: 0, row: 7};
            case PortalPermissionsEnum.SubscriptionManagementViewMarketDataUsageReports:
                return {col: 0, row: 8};
            case PortalPermissionsEnum.SubscriptionManagementViewRevenue:
                return {col: 0, row: 9};
            case PortalPermissionsEnum.SubscriptionManagementViewSubscriptionPrice:
                return {col: 0, row: 10};
            default:
                return {col: 0, row: 0};
        }
    }

    static getPortalUsersPermissionPosition(permissionString: string): PositionInterface {
        switch (permissionString) {
            case PortalPermissionsEnum.AddNewClientUser:
                return {col: 0, row: 0};
            case PortalPermissionsEnum.ViewClientUserDetails:
                return {col: 0, row: 1};
            case PortalPermissionsEnum.EditClientUserDetails:
                return {col: 0, row: 2};
            case PortalPermissionsEnum.DeleteClientUser:
                return {col: 0, row: 3};
            default:
                return {col: 0, row: 0};
        }
    }

    static getPortalCurrencyExchangePosition(permissionString: string): PositionInterface {
        switch (permissionString) {
            case PortalPermissionsEnum.CurrencyExchangeExchangeCurrency:
                return { col: 0, row: 0 };
            case PortalPermissionsEnum.CurrencyExchangeViewCurrencyTransactions:
                return { col: 0, row: 1 };
            default:
                return { col: 0, row: 0 };
        }
    }

    static getPortalFundPortalPosition(permissionString: string): PositionInterface {
        switch (permissionString) {
            case PortalPermissionsEnum.FPManageAccounts:
                return { col: 0, row: 0 };
            case PortalPermissionsEnum.FPDocumentsView:
                return { col: 0, row: 1 };
            case PortalPermissionsEnum.FPDocumentsUploadNew:
                return { col: 0, row: 2 };
            case PortalPermissionsEnum.FPDocumentsUpdate:
                return { col: 0, row: 3 };
            case PortalPermissionsEnum.FPDocumentsDownloadPreview:
                return { col: 0, row: 4 };
            case PortalPermissionsEnum.FPDocumentsDelete:
                return { col: 0, row: 5 };
            default:
                return { col: 0, row: 0 };
        }
    }


    static getTradingAccountAccessPermissionsPosition(permissionString: string): PositionInterface {
        switch (permissionString) {
            case PortalPermissionsEnum.TradingAccountsView:
                return {col: 0, row: 0};
            case PortalPermissionsEnum.TradingAccountsEdit:
                return {col: 1, row: 0};
            case PortalPermissionsEnum.TradingAccountsViewReports:
                return {col: 2, row: 0};
            case PortalPermissionsEnum.TradingAccountsExecuteTrades:
                return {col: 3, row: 0};
            case PortalPermissionsEnum.TradingAccountsCreateNewDeposits:
                return {col: 0, row: 1};
            case PortalPermissionsEnum.TradingAccountsCreateNewWithdrawals:
                return {col: 1, row: 1};
            case PortalPermissionsEnum.TradingAccountsCreateNewTransfers:
                return {col: 2, row: 1};
            case PortalPermissionsEnum.TradingAccountsExchangeCurrency:
                return {col: 3, row: 1 };
            case PortalPermissionsEnum.FPManageAccounts:
                return {col: 0, row: 2};
            default:
                return {col: 0, row: 0};
        }
    }

    static getCashAccountAccessPermissionsPosition(permissionString: string): PositionInterface {
        switch (permissionString) {
            case PortalPermissionsEnum.CashAccountsView:
                return {col: 0, row: 0};
            case PortalPermissionsEnum.CashAccountsEdit:
                return {col: 1, row: 0};
            case PortalPermissionsEnum.CashAccountsViewReports:
                return {col: 2, row: 0};
            case PortalPermissionsEnum.TradingAccountsCreateNew:
                return {col: 3, row: 0};
            case PortalPermissionsEnum.TradingAccountsDelete:
                return {col: 0, row: 1};
            case PortalPermissionsEnum.CashAccountsCreateNewDeposits:
                return {col: 1, row: 1};
            case PortalPermissionsEnum.CashAccountsCreateNewWithdrawals:
                return {col: 2, row: 1};
            case PortalPermissionsEnum.CashAccountsCreateNewTransfers:
                return {col: 3, row: 1};
            case PortalPermissionsEnum.FPManageAccounts:
                return {col: 0, row: 2};
            default:
                return {col: 0, row: 0};
        }
    }

    static getSupervisedPermissionPosition(permissionString: string): PositionInterface {
        switch (permissionString) {
            case PortalPermissionsEnum.ViewSupervisedUserDetails:
                return {col: 0, row: 0};
            case PortalPermissionsEnum.EditSupervisedUserDetails:
                return {col: 1, row: 0};
            case PortalPermissionsEnum.DeleteSupervisedUser:
                return {col: 2, row: 0};
            default:
                return {col: 0, row: 0};
        }
    }
}
